// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import DropdownArrow from '../_raw/ui/icon_dropdown_arrow.svg';
import withIconProps from '../withIconProps';

export default withIconProps(DropdownArrow);
